module.exports = __webpack_public_path__ + "static/img/byconcept-05.8601e7f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/byconcept-05.webp
// module id = 71
// module chunks = 0